import { render, staticRenderFns } from "./ModalMessages.vue?vue&type=template&id=1f75b64a&"
import script from "./ModalMessages.vue?vue&type=script&lang=js&"
export * from "./ModalMessages.vue?vue&type=script&lang=js&"
import style0 from "./ModalMessages.vue?vue&type=style&index=0&id=1f75b64a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports